import { Component, OnInit } from '@angular/core';
import { Procedure } from '../../models/Procedure';
import { Observable } from 'rxjs/Observable';
import { User } from '../../models/User';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { SpinnerService } from '../../services/spinner.service';
import { StoreService } from '../../services/store.service';

@Component({
  selector: 'app-procedure-list',
  templateUrl: './procedure-list.component.html',
  styleUrls: ['./procedure-list.component.css']
})
export class ProcedureListComponent implements OnInit {

  procedures$: Observable<Procedure[]>;
  procedure: Procedure;
  selectedProcedure: Procedure = new Procedure();
  newProcedure: boolean;
  displayDialog: boolean;
  user: User;
  cols: any[];
  constructor(public authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private messageService: MessageService,
    private spinnerService: SpinnerService,
    private storeService: StoreService) {
  }

  ngOnInit() {
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'creationUser', header: 'CreatedBy' },
      { field: 'creationDate', header: 'CreatedOn' }
    ];
    this.authService.getLogged().subscribe(
      user => {
        this.user = user;
      }
    );
    this.procedures$ = this.storeService.procedures$;
    this.storeService.loadProcedures();
  }

  manageSavedOk = e => {
    this.procedure = null;
    this.displayDialog = false;
    this.spinnerService.displayLoader(false);
  };

  manageSavedError = error => {
    this.messageService.add({
      severity: "error",
      summary: this.translate.instant('Error_Performing_Operation_Title'),
      detail: this.translate.instant('Error_Save_Procedure', { value: error.message })
    });
    this.spinnerService.displayLoader(false);
    this.procedure = null;
    this.displayDialog = false;
  };

  save() {
    //update
    console.log("Updating ", this.procedure);
    if (this.formDataValid(this.procedure)) {
      this.spinnerService.displayLoader(true);
      if (!this.procedure.id) {
        this.procedure.creationDate = new Date().toLocaleString();
        this.procedure.creationUser = this.user.name + " " + this.user.surname;
        this.procedure.procedureUnits = [];
        this.storeService
          .addProcedure(this.procedure)
          .subscribe(this.manageSavedOk, this.manageSavedError);
      }
    }
  }

  formDataValid(procedure: Procedure) {
    let dataValid = true;
    let errorMessages: string[] = [];

    if (!procedure.name) errorMessages.push(this.translate.instant('Error_Required_Name'));

    if (errorMessages.length > 0) {
      dataValid = false;
      this.messageService.add({
        severity: "error",
        summary: this.translate.instant('Error_Formulary'),
        detail: errorMessages.join("<p></p>")
      });
    }
    return dataValid;
  }

  onRowSelect(event) {
    this.router.navigate(["procedures", event.data.id]);
  }

  showDialogToAdd() {
    this.newProcedure = true;
    this.procedure = new Procedure();
    this.procedure.companyId = this.user.companyId;
    this.procedure.conections = [];
    this.procedure.procedureUnits = [];
    this.displayDialog = true;
  }

  hasRoleAdd(): boolean {
    if (this.user) {
      if (this.user.roles) return this.user.roles.includes("PROCEDURE.CREATE") || this.user.roles.includes("COMPANY_ADMIN");
    }
  }
}

